var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"flex items-center"},[_c('VlIcon',{staticClass:"pt-1",attrs:{"icon":"clock"}}),_c('span',{staticClass:"ml-4",style:({ width: '40px' })},[_vm._v(" "+_vm._s(_vm._f("secondsToTime")(_vm.props.seconds))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }